import { Line, Text, Layer } from 'react-konva';
import React from 'react';
import Konva from 'konva';
import { useTranslation } from 'react-i18next';
import { DEFAULT_GROUND_COLOR, PATH_WIDTH, PATH_WIDTH_HOVER } from '../track/ground/constants';
import { PlayersLinkProps } from '../../types/webPlayer';

const isValidLink = (point1: [number, number], point2: [number, number]) => point1[0] !== 0 && point1[1] !== 0
  && point2[0] !== 0 && point2[1] !== 0;

/**
 * Renders a set of player links on a canvas layer.
 *
 * @param props - The props object containing playersLines and removeLink.
 * @returns - The rendered layer of player links.
 */
const PlayersLinks = (props: PlayersLinkProps) => {
  const {
    playersLines,
    removeLink,
    groundSurfaceColor,
    scale,
  } = props;

  const [isHover, setHover] = React.useState({});

  const handleMouseEnter = (idx: number) => {
    setHover((prev) => ({
      ...prev,
      ...{ [idx]: true },
    }));
  };

  const handleMouseLeave = (idx: number) => {
    setHover((prev) => ({
      ...prev,
      ...{ [idx]: false },
    }));
  };

  const { t } = useTranslation();

  return (
    <Layer id="layer-players-links">
      {
        playersLines.map((player, idx) => (isValidLink(player.start, player.end) ? (
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={idx}>
            <Line
              hitStrokeWidth={3}
              onClick={() => removeLink(idx)}
              onMouseEnter={() => handleMouseEnter(idx)}
              onMouseLeave={() => handleMouseLeave(idx)}
              points={[
                player.start[0] * scale,
                player.start[1] * scale,
                player.end[0] * scale,
                player.end[1] * scale,
              ]}
              stroke="#000"
              strokeWidth={isHover[idx] ? PATH_WIDTH_HOVER : PATH_WIDTH}
            />
            <Text
              fill={groundSurfaceColor === 'rgb(0,221,181)' || groundSurfaceColor === DEFAULT_GROUND_COLOR
                ? '#333'
                : '#ccc'}
              height={10}
              fontSize={10}
              fontStyle={isHover[idx] ? 'bold' : 'normal'}
              fontFamily="Roboto"
              onClick={() => removeLink(idx)}
              onMouseEnter={() => handleMouseEnter(idx)}
              onMouseLeave={() => handleMouseLeave(idx)}
              text={`${String(player.distance)}`}
              width={30}
              x={scale * (player.start[0] + player.end[0]) / 2 + 5}
              y={scale * (player.start[1] + player.end[1]) / 2 + 5}
            />

            {
              isHover[idx]
              && (
                <Text
                  fill="#5b5b5b"
                  fontSize={12}
                  fontStyle={isHover[idx] ? 'bold' : 'normal'}
                  fontFamily="Roboto"
                  onClick={() => removeLink(idx)}
                  onMouseEnter={() => handleMouseEnter(idx)}
                  onMouseLeave={() => handleMouseLeave(idx)}
                  text={t('session.dialog.removeConnection', 'click to remove connection')}
                  x={scale * (player.start[0] + player.end[0]) / 2 + 5}
                  y={scale * (player.start[1] + player.end[1]) / 2 + 25}
                  sceneFunc={(con, shape) => {
                    if (isHover[idx]) {
                      // eslint-disable-next-line no-param-reassign
                      con.fillStyle = '#fff4e5';
                      con.fillRect(0 - 4, -2, shape.width() + 8, shape.height() + 4);
                      // eslint-disable-next-line no-underscore-dangle
                      (shape as Konva.Text)._sceneFunc(con);
                    }
                  }}
                />
              )
            }

          </React.Fragment>
        ) : null))
      }
    </Layer>
  );
};

export default PlayersLinks;
